/* eslint-disable react/no-danger */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import AttachmentsView from 'Modules/AttachmentsView/AttachmentsView';
import moment from 'moment';
import { bool, shape, string } from 'prop-types';
import { List } from 'semantic-ui-react';
import { parse } from 'marked';
import { CircleGauge, FileText } from 'lucide-react';
import EvaluationContent from 'Containers/Teleconsult/Main/FinishConsult/Review/Evaluation/EvaluationContent';
import SummaryTab from 'Components/SummaryTab/SummaryTab';
import { useSelector } from 'react-redux';
import { useMemo } from 'react';

import styles from './styles.less';

const InfoItem = ({ title, value, isOptional }) => (
  <List.Item className={styles.listItem}>
    <p className={styles.listItemTitle}>
      {title} {isOptional && <span className={styles.optionalText}>(optional)</span>}
    </p>
    <div className={styles.listItemContent}>
      <div dangerouslySetInnerHTML={{ __html: parse(value ?? '') }} />
    </div>
  </List.Item>
);
InfoItem.propTypes = {
  title: string.isRequired,
  value: string.isRequired,
  isOptional: bool,
};

InfoItem.defaultProps = {
  isOptional: false,
};

const NoteContent = ({
  title,
  clinicalNotes,
  summary,
  plan,
  followUpDate,
  privateNote,
  attachments,
  updatedAt,
}) => (
  <>
    <p className={styles.title}>{title}</p>
    <p className={styles.lastEdit}>{moment(updatedAt).format('MMM DD, YYYY - HH:mm')}</p>
    <List>
      <InfoItem title="Clinical Notes" value={clinicalNotes} />
      <InfoItem title="Diagnosis" value={summary} />
      <InfoItem title="Plan" value={plan || 'N/A'} />
      <InfoItem
        title="Follow up visit"
        value={followUpDate ? moment(followUpDate).format('MMM DD, YYYY') : 'N/A'}
        isOptional
      />
      <InfoItem title="Note" value={privateNote || 'N/A'} isOptional />
      <AttachmentsView attachments={attachments ?? []} />
    </List>
  </>
);

const SummaryDetails = props => {
  const { healthSummary } = props;
  const {
    title,
    clinicalNotes,
    plan,
    privateNote,
    summary,
    followUpDate,
    updatedAt,
    attachments = [],
    evaluation,
  } = healthSummary;

  const {
    data: { enableAiChecker },
  } = useSelector(state => state.webChat.doctor);

  const items = useMemo(
    () => [
      {
        key: '1',
        label: 'Notes',
        children: (
          <NoteContent
            title={title}
            clinicalNotes={clinicalNotes}
            summary={summary}
            plan={plan}
            followUpDate={followUpDate}
            privateNote={privateNote}
            attachments={attachments}
            updatedAt={updatedAt}
          />
        ),
        icon: <FileText size={16} />,
      },
      {
        key: '2',
        label: 'AI Checker’s Evaluation',
        children: <EvaluationContent evaluation={evaluation} />,
        icon: <CircleGauge size={16} />,
      },
    ],
    [
      attachments,
      clinicalNotes,
      evaluation,
      followUpDate,
      plan,
      privateNote,
      summary,
      title,
      updatedAt,
    ],
  );
  return enableAiChecker ? <SummaryTab items={items} /> : <NoteContent {...healthSummary} />;
};

SummaryDetails.propTypes = {
  healthSummary: shape({}),
};

SummaryDetails.defaultProps = {
  healthSummary: {
    plan: '',
    clinicalNotes: '',
    title: '',
    privateNote: '',
    visitDoctorIf: '',
    summary: '',
    followUpDate: '',
    updatedAt: '',
  },
};

export default SummaryDetails;
